/* FB | Onay yardimcilari (ADDITIVE, calisan akisi bozmaz):
   0) Drawer ici kaydirma body'ye zincirlenmesin (overscroll-behavior, SADECE drawer ici -> ana sayfaya ETKI YOK).
   1) "Satin Al" (#fbBuyNow) onay penceresi.
   2) Sepet onay kutusu (#fb-consent-check) -> OZEL panel (beyaz + sol uyari ikonu + ok), TOP LAYER (popover).
      Drawer KAPANINCA panel ANINDA kaldirilir (canli DOM poll + global close event). */
(function () {
  if (window.__fbBuyConsentGate) return;
  window.__fbBuyConsentGate = true;

  /* ---------- 0) Drawer ici scroll zincirleme (SADECE drawer ici; ana sayfayi KILITLEMEZ/etkilemez) ---------- */
  try {
    var fbLock = document.createElement('style');
    fbLock.textContent =
      'cart-drawer-component dialog[open]{overscroll-behavior:contain !important;}' +
      'cart-drawer-component .cart-drawer__items{overscroll-behavior:contain !important;-webkit-overflow-scrolling:touch;}';
    (document.head || document.documentElement).appendChild(fbLock);
  } catch (e) {}

  var LINKS =
      '<a href="/policies/terms-of-service" target="_blank" rel="nofollow">Mesafeli Satış Sözleşmesi</a>, ' +
      '<a href="/policies/privacy-policy" target="_blank" rel="nofollow">KVKK Aydınlatma Metni</a> ve ' +
      '<a href="/policies/refund-policy" target="_blank" rel="nofollow">İade Koşulları</a>’nı okudum, onaylıyorum.';

  /* ---------- 1) SATIN AL onay penceresi ---------- */
  var overlay = null, card = null, chk = null, goBtn = null, pendingBtn = null, allow = false;

  function build() {
    overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;z-index:2147483600;background:rgba(40,28,14,.55);display:none;align-items:center;justify-content:center;padding:20px;opacity:0;transition:opacity .18s ease;';
    card = document.createElement('div');
    card.setAttribute('role', 'dialog');
    card.setAttribute('aria-modal', 'true');
    card.style.cssText = 'position:relative;background:#F5EAD8;max-width:360px;width:100%;border-radius:16px;padding:22px 22px 18px;box-shadow:0 30px 80px -20px rgba(40,28,14,.55);transform:translateY(10px);transition:transform .18s ease;font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif;';
    card.innerHTML =
        '<h3 style="margin:0 0 15px;font-size:17px;font-weight:600;color:#3A2C1E;text-align:center;">Son bir adım</h3>' +
        '<label class="fb-consent" style="margin:0 0 16px;">' +
          '<input type="checkbox" class="fb-consent__input" autocomplete="off" data-buyc-chk>' +
          '<span class="fb-consent__text" style="color:#3A2C1E;opacity:.92;">' + LINKS + '</span>' +
        '</label>' +
        '<button type="button" data-buyc-go disabled style="width:100%;background:#D95422;color:#fff;border:0;border-radius:999px;padding:13px 16px;font-size:15px;font-weight:600;cursor:pointer;opacity:.5;font-family:inherit;">Onayla ve Ödemeye Geç</button>' +
        '<button type="button" data-buyc-cancel style="width:100%;margin-top:8px;background:none;border:0;color:#3A2C1E;opacity:.55;font-size:14px;cursor:pointer;font-family:inherit;">Vazgeç</button>';
    overlay.appendChild(card);
    document.body.appendChild(overlay);
    chk = card.querySelector('[data-buyc-chk]');
    goBtn = card.querySelector('[data-buyc-go]');
    var cancelBtn = card.querySelector('[data-buyc-cancel]');
    chk.addEventListener('change', function () { goBtn.disabled = !chk.checked; goBtn.style.opacity = chk.checked ? '1' : '.5'; });
    goBtn.addEventListener('click', function () { if (!chk.checked) return; hide(); allow = true; if (pendingBtn) { try { pendingBtn.click(); } catch (e) {} } });
    cancelBtn.addEventListener('click', hide);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) hide(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay && overlay.style.display === 'flex') hide(); });
  }
  function showModal(btn) {
    pendingBtn = btn;
    if (!overlay) build();
    chk.checked = false; goBtn.disabled = true; goBtn.style.opacity = '.5';
    overlay.style.display = 'flex'; void overlay.offsetWidth; overlay.style.opacity = '1'; card.style.transform = 'translateY(0)';
  }
  function hide() {
    if (!overlay) return;
    overlay.style.opacity = '0'; card.style.transform = 'translateY(10px)';
    setTimeout(function () { if (overlay) overlay.style.display = 'none'; }, 200);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('#fbBuyNow');
    if (!btn) return;
    if (allow) { allow = false; return; }
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    try { showModal(btn); }
    catch (err) { if (window.confirm('Mesafeli Satış Sözleşmesi, KVKK Aydınlatma Metni ve İade Koşulları’nı okudum, onaylıyorum.')) { allow = true; try { btn.click(); } catch (e2) {} } }
  }, true);

  /* ---------- 2) SEPET onay kutusu: BEYAZ panel + uyari ikonu + ok, TOP LAYER ---------- */
  var msgEl = null, msgArrow = null, msgTimer = null, msgBox = null, msgPoll = null;
  function clearDrawerWatch() { if (msgPoll) { try { clearInterval(msgPoll); } catch (e) {} msgPoll = null; } }
  function watchDrawerClose(box) {
    clearDrawerWatch();
    var inDrawer = box && box.closest && box.closest('cart-drawer-component, .cart-drawer');
    if (!inDrawer) return;
    msgPoll = setInterval(function () {
      if (!document.querySelector('cart-drawer-component dialog[open]')) removeCartMsg();
    }, 100);
  }
  function placeMsg() {
    if (!msgEl || !msgBox) return;
    var r = msgBox.getBoundingClientRect();
    var w = msgEl.offsetWidth, h = msgEl.offsetHeight;
    var vw = window.innerWidth, vh = window.innerHeight;
    var boxCX = r.left + r.width / 2;
    var below = false;
    var left = boxCX - 18;
    var top = r.top - h - 10;
    if (top < 6) { top = r.bottom + 10; below = true; }
    if (left + w > vw - 6) left = vw - 6 - w;
    if (left < 6) left = 6;
    if (top < 6) top = 6;
    msgEl.style.left = Math.round(left) + 'px';
    msgEl.style.top = Math.round(top) + 'px';
    msgEl.style.visibility = 'visible';
    if (msgArrow) {
      var ax = boxCX - left;
      ax = Math.max(11, Math.min(w - 11, ax));
      if (below) {
        msgArrow.style.cssText = 'position:absolute;left:' + Math.round(ax - 5) + 'px;top:-5px;width:10px;height:10px;background:#fff;transform:rotate(45deg);box-shadow:-2px -2px 4px rgba(0,0,0,.10);';
      } else {
        msgArrow.style.cssText = 'position:absolute;left:' + Math.round(ax - 5) + 'px;bottom:-5px;width:10px;height:10px;background:#fff;transform:rotate(45deg);box-shadow:2px 2px 4px rgba(0,0,0,.10);';
      }
    }
  }
  function showCartMsg(box) {
    removeCartMsg();
    msgBox = box;
    msgEl = document.createElement('div');
    msgEl.setAttribute('data-fbmsg', '1');
    msgEl.style.cssText = 'position:fixed;inset:auto;margin:0;z-index:2147483601;display:flex;align-items:center;gap:6px;width:max-content;max-width:calc(100vw - 16px);height:auto;background:#ffffff;color:#262626;font-size:12px;font-weight:500;line-height:1.35;padding:7px 11px 7px 9px;border:0;border-radius:6px;white-space:nowrap;box-shadow:0 4px 16px -2px rgba(0,0,0,.28);font-family:system-ui,-apple-system,sans-serif;pointer-events:none;left:0;top:0;visibility:visible;overflow:visible;';
    var ic = document.createElement('span');
    ic.style.cssText = 'flex:0 0 auto;display:inline-flex;line-height:0;';
    ic.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.27 3.5c.77-1.33 2.69-1.33 3.46 0l7.79 13.5c.77 1.33-.19 3-1.73 3H4.21c-1.54 0-2.5-1.67-1.73-3l7.79-13.5z" fill="#D95422"/><path d="M12 9v4.1" stroke="#fff" stroke-width="2.1" stroke-linecap="round"/><circle cx="12" cy="16.7" r="1.15" fill="#fff"/></svg>';
    msgEl.appendChild(ic);
    var txt = document.createElement('span');
    txt.textContent = 'Lütfen bu kutuyu işaretleyin';
    msgEl.appendChild(txt);
    msgArrow = document.createElement('span');
    msgArrow.style.cssText = 'position:absolute;left:12px;bottom:-5px;width:10px;height:10px;background:#fff;transform:rotate(45deg);box-shadow:2px 2px 4px rgba(0,0,0,.10);';
    msgEl.appendChild(msgArrow);
    var ok = false;
    if (typeof msgEl.showPopover === 'function') {
      msgEl.setAttribute('popover', 'manual');
      document.body.appendChild(msgEl);
      try { msgEl.showPopover(); ok = true; } catch (e) {}
    }
    if (!ok) {
      var host = (box.closest && (box.closest('dialog') || box.closest('cart-drawer-component, .cart-drawer'))) || document.body;
      host.appendChild(msgEl);
    }
    placeMsg();
    requestAnimationFrame(function () { requestAnimationFrame(placeMsg); });
    watchDrawerClose(box);
    clearTimeout(msgTimer); msgTimer = setTimeout(removeCartMsg, 4000);
  }
  function removeCartMsg() { clearDrawerWatch(); if (msgEl) { try { if (msgEl.hidePopover && msgEl.matches && msgEl.matches(':popover-open')) msgEl.hidePopover(); } catch (e) {} try { msgEl.remove(); } catch (e2) {} msgEl = null; msgArrow = null; msgBox = null; } }
  document.addEventListener('invalid', function (e) {
    if (!e.target || e.target.id !== 'fb-consent-check') return;
    e.preventDefault();
    showCartMsg(e.target);
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'fb-consent-check' && e.target.checked) removeCartMsg();
  });
  document.addEventListener('close', function () { removeCartMsg(); }, true);
  window.addEventListener('scroll', function () { if (msgEl) placeMsg(); }, true);
  window.addEventListener('resize', function () { if (msgEl) placeMsg(); }, true);
})();